export function mapRange(value, inMin, inMax, outMin, outMax) {
  if (value <= inMin) {
    return outMin;
  }

  if (value >= inMax) {
    return outMax;
  }
  // Calculate the proportion of the value within the input range
  const normalizedValue = (value - inMin) / (inMax - inMin);

  // Apply that proportion to the output range
  const mappedValue = normalizedValue * (outMax - outMin) + outMin;
  return mappedValue;
}
